// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b62e4aa7","977":"42d81a85"}[chunkId] + ".chunk.js";
};